import React from "react";
import { AppBar, Toolbar, Box } from "@mui/material";
import { Link } from "react-router-dom";
import NavItemControl from "../../controls/navitems-control";
import "../../assets/css/index.css";
import { PAGE } from "../../config/urls";
import logo from "../../assets/images/logo.jpg";
import { useScrolled } from "../../hooks/useScrolled";

const Header: React.FC = () => {
  const scrolled = useScrolled(50);

  return (
    <AppBar
      position="fixed"
      elevation={0}
      className={`app-header ${scrolled ? "scrolled" : ""}`}
      component="header"
    >
      <Toolbar className="header-toolbar">
        {/* Logo */}
        <Box className="header-logo">
          <Link to={PAGE.DEFAULT} className="logo-link">
            <img
              src={logo}
              alt="BM Homes Logo"
              className="header-logo-image"
              width={52}
              height={52}
            />
            <span className="logo-text">BM Homes</span>
          </Link>
        </Box>

        {/* Navigation */}
        <NavItemControl />
      </Toolbar>
    </AppBar>
  );
};

export default React.memo(Header);
